<template>
    <label :for="elementId" class="checkbox-wrapper">{{label}}
        <input :id="elementId" :name="elementId" type="checkbox" v-model="newValue">
        <span class="custom-checkbox"></span>
    </label>
</template>

<script>

import guidMixin from '../../Util/Mixins/guid';

export default {
    name: 'checkbox',
    mixins: [guidMixin],
    created() {
        this.newValue = this.value;
    },
    watch: {
        newValue(value) {
            this.$emit('input', value);
        }
    },
    data() {
        return {
            elementId: `check-${this.guid()}`,
            newValue: null
        }
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped src="./Style/checkbox.scss">

</style>